module.exports = __webpack_public_path__ + "static/img/Myfreecams.1a579d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plataformas/Myfreecams.png
// module id = x372
// module chunks = 1